import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

export const offeringsRoutes: RouteRecordRaw[] = [
  {
    path: routes.PROPERTIES,
    name: 'PROPERTIES',
    component: () => import('./PropertiesPage.vue'),
    meta: { requiresAuth: true },
  },
]
